import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { getMenuList } from "../../../redux/slices/Menu";
import {
  getAllOutlets,
  getOutletDetail,
  setCommision,
  setRewardPoint,
} from "../../../redux/slices/Outlet";
import { getCategories } from "../../../redux/slices/Registration";
import { getOrders } from "../../../redux/slices/Orders";
import useRequest from "../../../hooks/useRequest";
import {
  clearAllDetails,
  outletStepFourSave,
  outletStepOneSave,
  outletStepThreeSave,
  outletStepTwoSave,
} from "../../../redux/slices/SaveOutletDetails";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import Swal from "sweetalert2";
import useRequest2 from "../../../hooks/useRequest2";
import OutletBankDetailsModal from "./OutletBankDetailsModal";

const OutletGrids = () => {
  const dispatch = useDispatch();
  const { request: requestStatusUpdate, response: responseStatusUpdate } =
    useRequest();
  const { request: requestStatusUpdate1, response: responseStatusUpdate1 } =
    useRequest();
  const { response: responseOtherFacilities, request: requestOtherFacilities } =
    useRequest2();
  const [showRewardModal, setShowRewardModal] = useState(false);
  const [otherFacilities, setOtherFacilities] = useState(false);
  const [otherFacilitiesids, setOtherFacilitiesids] = useState([]);
  const [showCommisionModal, setShowCommisionModal] = useState(false);
  const [showOutletBankModal, setShowOutletBankModal1] = useState(false);
  const [selectedOutletId, setSelectedOutletId] = useState("");
  const [sliderValue, setSliderValue] = useState(0);
  const history = useHistory();
  const handleShowRewardModal = () => setShowRewardModal(!showRewardModal);
  const handleShowCommisionModal = (commision) => {
    setSliderValue(commision);
    setShowCommisionModal(!showCommisionModal);
  };

  const [outletList, setOutletList] = useState([]);
  // const { vendorId } = useSelector((state) => state.register);
  const vendorId = localStorage.getItem("vendorId");
  useEffect(() => {
    requestOtherFacilities("POST", "manageCategory/getCategorys", {
      type: "otherFacilities",
    });
  }, []);
  useEffect(() => {
    if (responseOtherFacilities) {
      if (
        responseOtherFacilities?.status == true ||
        responseOtherFacilities?.status == "success"
      ) {
        let ids = responseOtherFacilities?.data?.map((val) => val?._id);
        setOtherFacilities(responseOtherFacilities?.data);
        setOtherFacilitiesids(ids);
      }
    }
  }, [responseOtherFacilities]);

  useEffect(() => {
    dispatch(getAllOutlets({ vendorId: vendorId }))
      .unwrap()
      .then((res) => {
        if (res?.status == "success" || res?.status == true) {
          setOutletList(res?.data);
        }
      })
      .catch((err) => {});
  }, [responseStatusUpdate]);

  const renderRewardModal = () => {
    return (
      <Modal
        show={setShowRewardModal}
        onHide={handleShowRewardModal}
        style={{ height: "90vh", maxHeight: "90vh", overflow: "hidden" }}
        scrollable
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Reward point partner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          5% reward point will be offered as reward loyalty program
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              dispatch(
                setRewardPoint({
                  status: "false",
                  outletId: localStorage.getItem("outletId"),
                }),
              )
                .unwrap()
                .then(() => {
                  toast.success("Reward partner points activated successfully");
                  handleShowRewardModal();
                })
                .catch((err) => {
                  toast.error(err);
                  handleShowRewardModal();
                });
            }}
          >
            Deactivate
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              dispatch(
                setRewardPoint({
                  status: "true",
                  outletId: localStorage.getItem("outletId"),
                }),
              )
                .unwrap()
                .then(() => {
                  toast.success("Reward partner points activated successfully");
                  handleShowRewardModal();
                })
                .catch((err) => {
                  toast.error(err);
                  handleShowRewardModal();
                });
            }}
          >
            Activate
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  const renderCommisionModal = (outletId) => {
    return (
      <Modal
        show={setShowCommisionModal}
        onHide={handleShowCommisionModal}
        style={{ height: "90vh", maxHeight: "90vh", overflow: "hidden" }}
        scrollable
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Commision</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row style={{ marginBottom: "25px" }}>
            <Col md={6}>
              <label htmlFor="foodLicence" className="form-label customLabel">
                Commision
              </label>
              <Slider
                orientation="horizontal"
                min={5}
                max={100}
                value={sliderValue}
                onChange={(val) => setSliderValue(val)}
              />
              {sliderValue} %
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleShowCommisionModal}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              dispatch(
                setCommision({
                  commission: sliderValue,
                  outletId: outletId,
                }),
              )
                .unwrap()
                .then(() => {
                  toast.success("Commission set successfully");
                  handleShowCommisionModal();
                })
                .catch((err) => {
                  toast.error(err);
                  handleShowCommisionModal();
                });
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const ActiveDeactive = async (id, status) => {
    let newStatus = status == "active" ? "inActive" : "active";
    Swal.fire({
      title: "Are you sure?",
      text: "You want to " + newStatus?.toLocaleLowerCase() + " this outlet",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.value) {
        requestStatusUpdate("POST", "outlet/updateOutletStatus", {
          outletId: id,
          status: newStatus,
        });
      }
    });
  };

  const closeOpen = async (id, status) => {
    requestStatusUpdate("POST", "outlet/updateOutletCloseStatus", {
      outletId: id,
      isClosed: status,
    });
  };

  const handleFacilityStatus = (id, oldfacility, outletFacility, index) => {
    let datas = oldfacility?.find(
      (val) => val?.toString() == outletFacility?.toString(),
    );
    let SaveArray = datas
      ? oldfacility?.filter((val) => val != outletFacility)
      : [...oldfacility, outletFacility];

    setOutletList((prev) =>
      prev.map((facility, i) =>
        index == i
          ? {
              ...facility,
              otherFacilities: [...SaveArray],
            }
          : facility,
      ),
    );

    requestStatusUpdate1("POST", "outlet/updateOtherFacilities", {
      outletId: id,
      otherFacilities: [...SaveArray],
    });
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            {outletList?.length > 0
              ? outletList.map((item, i) => (
                  <div key={i} className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                    <div className="ms-card">
                      <div className="ms-card-imgssss">
                        {item && item.image && (
                          <img
                            // style={{
                            //   width: "100%",
                            //   height: "200px",
                            //   objectFit: "cover",
                            // }}
                            src={item.image}
                            alt="card_img"
                          />
                        )}
                      </div>
                      <div className="ms-card-body">
                        <div className="new">
                          <h6 className="mb-0">{item.outletName} </h6>

                          <Form.Check // prettier-ignore
                            type="switch"
                            id={`custom-switch` + i}
                            checked={item?.isClosed == "yes" ? false : true}
                            onChange={(e) => {
                              e.preventDefault();
                              closeOpen(
                                item?.outletId,
                                item?.isClosed == "yes" ? "no" : "yes",
                              );
                            }}
                          />

                          <h6 className="ms-text-primary mb-0">{i + 1}</h6>
                        </div>
                        <div classNamtotalCuisinee="new meta">
                          {/* <p>Qty:{item.qyt} </p> */}
                          {/* <span className={item.statuscls}>{item.status}</span> */}
                        </div>
                        <p>{item.description}</p>
                        <div className="new mb-0 mt-3">
                          <button
                            type="button"
                            className="btn grid-btn mt-0 btn-sm steps-btn"
                            onClick={() => {
                              history.push(`/view-outlet/${item.outletId}`);

                              // dispatch(getOutletDetail({ outletId: item.outletId }))
                              //   .unwrap()
                              //   .then((res) => {
                              //     history.push(`/view-outlet/${item.outletId}`);
                              //   })
                              //   .catch((err) => {
                              //     toast.error(err);
                              //   });
                            }}
                          >
                            View
                          </button>
                          <button
                            type="button"
                            className="btn grid-btn mt-0 btn-sm edit-btn btn-btn-set"
                            onClick={() => {
                              dispatch(clearAllDetails());
                              history.push(`/edit-outlet/${item.outletId}`);
                            }}
                          >
                            Edit
                          </button>
                        </div>
                        <div className="new mt-4">
                          <button
                            type="button"
                            className={
                              item?.menuActive
                                ? "btn grid-btn mt-0 btn-sm steps-btn btn-btn-set"
                                : "btn grid-btn mt-0 btn-sm steps-btn btn-btn-set red-color-btn"
                            }
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onClick={() => {
                              dispatch(getCategories("cuisine")).then((res) => {
                                console.log(res);
                                dispatch(
                                  getMenuList({
                                    outletId: item.outletId,
                                    cusineId: res?.payload?.data[0]?._id,
                                  }),
                                )
                                  .unwrap()
                                  .then(() => {
                                    localStorage.setItem(
                                      "outletId",
                                      item.outletId,
                                    );
                                    history.push(`/menu-grid/${item.outletId}`);
                                  });
                              });
                            }}
                          >
                            Menu
                          </button>

                          <button
                            type="button"
                            className="btn grid-btn mt-0 btn-sm steps-btn"
                            onClick={() => {
                              dispatch(
                                getOrders({
                                  outletId: item.outletId,
                                }),
                              )
                                .unwrap()
                                .then(() => {
                                  localStorage.setItem(
                                    "outletId",
                                    item.outletId,
                                  );
                                  history.push(`/orders/${item.outletId}`);
                                });
                            }}
                          >
                            Orders
                          </button>
                        </div>
                        <div className="new mt-4">
                          <button
                            type="button"
                            className="btn grid-btn mt-0 btn-sm steps-btn"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onClick={() =>
                              handleShowCommisionModal(item.commissionPoint)
                            }
                          >
                            Commision
                          </button>

                          <Link
                            to={`/reward-page/${item.outletId}`}
                            className={
                              item?.rewardActive
                                ? "btn grid-btn mt-0 btn-sm steps-btn btn-btn-set"
                                : "btn grid-btn mt-0 btn-sm steps-btn btn-btn-set red-color-btn"
                            }
                            // onClick={handleShowRewardModal}
                          >
                            Reward point
                          </Link>
                          {showRewardModal && renderRewardModal()}
                          {showCommisionModal &&
                            renderCommisionModal(item.outletId)}
                        </div>
                        <div className="new mt-4">
                          <button
                            type="button"
                            className={
                              item?.discountActive
                                ? "btn grid-btn mt-0 btn-sm steps-btn btn-btn-set"
                                : "btn grid-btn mt-0 btn-sm steps-btn btn-btn-set red-color-btn"
                            }
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onClick={() => {
                              localStorage.setItem("outletId", item?.outletId);
                              history.push("/discount-grid");
                            }}
                          >
                            Discount
                          </button>

                          <button
                            type="button"
                            className="btn grid-btn mt-0 btn-sm steps-btn"
                            onClick={() => {
                              localStorage.setItem("outletId", item?.outletId);
                              history.push("/promotion-grid");
                            }}
                          >
                            Promotion
                          </button>
                          {showRewardModal && renderRewardModal()}
                          {showCommisionModal &&
                            renderCommisionModal(item.outletId)}
                        </div>
                        <div className="new mt-4">
                          <button
                            type="button"
                            className="btn grid-btn mt-0 btn-sm steps-btn btn-btn-set"
                            onClick={() => {
                              setSelectedOutletId(item?.outletId);
                              setShowOutletBankModal1(true);
                            }}
                          >
                            Bank Account
                          </button>
                          <button
                            className="btn grid-btn mt-0 btn-sm steps-btn"
                            onClick={() =>
                              ActiveDeactive(item?.outletId, item?.status)
                            }
                          >
                            {" "}
                            {item?.status == "inActive"
                              ? "Active"
                              : "Inactive"}{" "}
                          </button>
                        </div>
                        <div className="d-flex justify-content-center align-items-center">
                          {/* {otherFacilities?.map((val, i) => ( */}
                          <label className="mx-2 cursor-pointer">
                            <input
                              checked={item?.otherFacilities?.some(
                                (id) => id === otherFacilitiesids[0],
                              )}
                              onChange={(e) => {
                                handleFacilityStatus(
                                  item?.outletId,
                                  item?.otherFacilities,
                                  otherFacilitiesids[0],
                                  i,
                                );
                              }}
                              type="checkbox"
                            />{" "}
                            {otherFacilities?.[0]?.name}
                          </label>
                          <label className="mx-2 cursor-pointer">
                            <input
                              checked={item?.otherFacilities?.some(
                                (id) => id === otherFacilitiesids[1],
                              )}
                              //  checked={areArraysEqual(item?.otherFacilities, otherFacilitiesids?.split(","))}
                              onChange={(e) => {
                                handleFacilityStatus(
                                  item?.outletId,

                                  item?.otherFacilities,
                                  otherFacilitiesids[1],
                                  i,
                                );
                              }}
                              type="checkbox"
                            />{" "}
                            {otherFacilities?.[1]?.name}
                          </label>
                          <label className="mx-2 cursor-pointer">
                            <input
                              checked={item?.otherFacilities?.some(
                                (id) => id === otherFacilitiesids[2],
                              )}
                              onChange={(e) => {
                                handleFacilityStatus(
                                  item?.outletId,
                                  item?.otherFacilities,
                                  otherFacilitiesids[2],
                                  i,
                                );
                              }}
                              type="checkbox"
                            />{" "}
                            {otherFacilities?.[2]?.name}
                          </label>
                          {/* ))} */}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : "No outlet Found."}
          </div>
        </div>
      </div>
      {showOutletBankModal && (
        <OutletBankDetailsModal
          show={showOutletBankModal}
          outletId={selectedOutletId}
          onHide={() => {
            setShowOutletBankModal1(false);
            setSelectedOutletId("");
          }}
        />
      )}
    </div>
  );
};

export default OutletGrids;
